const dateElements = document.querySelectorAll(
	'.block-program-dates__date-data .aifsapi-data-item'
);

const initProgramDates = () => {
	let counter = 0;

	dateElements.forEach((dateElement) => {
		if (dateElement.childNodes.length > 0) {
			counter++;
			dateElement.parentElement.parentElement.parentElement.classList.add(
				'active'
			);

			if (counter % 2) {
				dateElement.parentElement.parentElement.parentElement.classList.add(
					'odd'
				);
			} else {
				dateElement.parentElement.parentElement.parentElement.classList.remove(
					'odd'
				);
			}
		} else {
			dateElement.parentElement.parentElement.parentElement.classList.remove(
				'active'
			);
		}
	});
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		if (dateElements.length) {
			initProgramDates();
			window.addEventListener('aifsapi-data-changed', initProgramDates);
		}
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
